const state = {
  isAuthenticated: false,
  isForgotPasswordMailSent: false,
  authToken: null,
  userInfo: null
}
export default state
